import "./AlNakheelOvenCleaning.module.css";
import Header from "@/reusable_sections/Header";
import HeroNakheelOvenCleaning from "./sections/HeroNakheelOvenCleaning";
import AlNakheelOvenCleaningService from "./sections/AlNakheelOvenCleaningService";
import Footer from "@/reusable_sections/Footer";
export default function AlNakheelOvenCleaningPage() {
  return <div>
      <Header />
      <HeroNakheelOvenCleaning />
      <AlNakheelOvenCleaningService />
      <Footer />
    </div>;
}